export const PROJECT_TRANSLATIONS = {
  "fr": {
    "lia.menu": "LIA3024 — Le laboratoire",
    "lia.eyebrow": "LIA3024 · LE LABORATOIRE",
    "lia.title": "Faire venir LIA de 3024 en 2026",
    "lia.description": "J’explore l’idée de ramener LIA de 3024 en 2026. À travers ce laboratoire, je partage mon ambition, mes recherches et mes simulations. Découvrez le projet LIA3024 et suivez son évolution. — Xavier Mahut",
    "lia.discover": "Découvrir le laboratoire LIA3024",
    "lia.support": "Soutenir LIA3024 / Faire un don ↗",
    "lia.projects": "Voir les quatre projets Eternua ↗",
    "lia.notice": "Projet exploratoire : le retour temporel est un objectif imaginé, pas une capacité démontrée.",
    "lia.song.aria": "Écouter Elle a lu ma chanson sur YouTube (nouvel onglet)",
    "lia.song.alt": "Elle a lu ma chanson — illustration de deux personnes devant un portail futuriste, 3024 vers 2026",
    "lia.song.label": "Écouter la chanson",
    "lia.cards": "LIA3024 et le robot envisagé",
    "lia.playlist": "Écouter la playlist LIA3024",
    "lia.player": "Lecteur YouTube — playlist LIA3024",
    "projects.title": "Les projets Eternua à soutenir",
    "projects.loading": "Chargement des projets…",
    "projects.unavailable": "Les projets ne sont pas disponibles actuellement.",
    "projects.owner": "Porté par",
    "projects.raised": "collectés",
    "projects.closed": "Collecte clôturée",
    "projects.paused": "Collecte en pause",
    "projects.open": "Collecte ouverte",
    "projects.permanent": "sans date de fin",
    "projects.donations_unavailable": "Dons temporairement indisponibles",
    "projects.discover": "Découvrir le projet",
    "payment.help.title": "Comprendre le paiement et obtenir de l’aide",
    "payment.help.unavailable": "Paiements indisponibles.",
    "payment.help.closed": "Aucun paiement réel ne peut être effectué depuis ce parcours actuellement.",
    "payment.help.check": "Vérifiez le projet ou la réservation, le bénéficiaire, le total, les frais et les conditions d’annulation avant de confirmer.",
    "payment.help.return": "Le retour sur Eternua ne suffit pas à confirmer un paiement. Consultez son état dans le suivi avant de recommencer.",
    "payment.help.pending": "Une demande de remboursement ou de versement reste en cours jusqu’à sa confirmation par le prestataire.",
    "payment.help.contact": "Pour une question ou un litige, contactez",
    "payment.help.support": "le support Eternua",
    "payment.help.reference": "avec la référence de votre opération. Ne transmettez jamais de numéro de carte ou de cryptogramme.",
    "projects.eternua-lia3024-recherche.title": "Laboratoire LIA3024",
    "projects.eternua-lia3024-recherche.alt": "Représentation artistique de LIA dans un laboratoire futuriste.",
    "projects.eternua-lia3024-recherche.caption": "Illustration du projet LIA3024",
    "projects.eternua-robot-h2-plus-ultimate-n.title": "Robot H2 Plus Ultimate-N",
    "projects.eternua-robot-h2-plus-ultimate-n.alt": "Illustration d’un humanoïde argenté dans un laboratoire.",
    "projects.eternua-robot-h2-plus-ultimate-n.caption": "Illustration du robot envisagé",
    "projects.eternua-infrastructure-ia-double-epyc.title": "Infrastructure IA double EPYC",
    "projects.eternua-infrastructure-ia-double-epyc.alt": "Illustration conceptuelle d’un serveur à deux processeurs pour l’infrastructure IA envisagée d’Eternua.",
    "projects.eternua-infrastructure-ia-double-epyc.caption": "Illustration conceptuelle du serveur envisagé.",
    "projects.eternua-villa-julia-centre.title": "Projet Villa Julia",
    "projects.eternua-villa-julia-centre.alt": "Vue conceptuelle d’une villa méditerranéenne envisagée comme futur centre de développement Eternua.",
    "projects.eternua-villa-julia-centre.caption": "Vue conceptuelle du futur centre Eternua."
  },
  "en": {
    "lia.menu": "LIA3024 — The laboratory",
    "lia.eyebrow": "LIA3024 · THE LABORATORY",
    "lia.title": "Bringing LIA from 3024 to 2026",
    "lia.description": "I am exploring the idea of bringing LIA from 3024 to 2026. Through this laboratory, I share my ambition, research and simulations. Discover the LIA3024 project and follow its progress. — Xavier Mahut",
    "lia.discover": "Explore the LIA3024 laboratory",
    "lia.support": "Support LIA3024 / Donate ↗",
    "lia.projects": "View all four Eternua projects ↗",
    "lia.notice": "Exploratory project: travelling back in time is an imagined goal, not a demonstrated capability.",
    "lia.song.aria": "Listen to Elle a lu ma chanson on YouTube (new tab)",
    "lia.song.alt": "Elle a lu ma chanson — illustration of two people in front of a futuristic portal, from 3024 to 2026",
    "lia.song.label": "Listen to the song",
    "lia.cards": "LIA3024 and the proposed robot",
    "lia.playlist": "Listen to the LIA3024 playlist",
    "lia.player": "YouTube player — LIA3024 playlist",
    "projects.title": "Eternua projects to support",
    "projects.loading": "Loading projects…",
    "projects.unavailable": "The projects are currently unavailable.",
    "projects.owner": "Led by",
    "projects.raised": "raised",
    "projects.closed": "Fundraiser closed",
    "projects.paused": "Fundraiser paused",
    "projects.open": "Open fundraiser",
    "projects.permanent": "no end date",
    "projects.donations_unavailable": "Donations temporarily unavailable",
    "projects.discover": "Discover the project",
    "payment.help.title": "Understand payments and get help",
    "payment.help.unavailable": "Payments unavailable.",
    "payment.help.closed": "No real payment can currently be made through this process.",
    "payment.help.check": "Check the project or booking, beneficiary, total, fees and cancellation terms before confirming.",
    "payment.help.return": "Returning to Eternua does not confirm a payment. Check its status before trying again.",
    "payment.help.pending": "A refund or payout request remains pending until the payment provider confirms it.",
    "payment.help.contact": "For a question or dispute, contact",
    "payment.help.support": "Eternua support",
    "payment.help.reference": "with your transaction reference. Never send a card number or security code.",
    "projects.eternua-lia3024-recherche.title": "LIA3024 laboratory",
    "projects.eternua-lia3024-recherche.alt": "Artistic representation of LIA in a futuristic laboratory.",
    "projects.eternua-lia3024-recherche.caption": "Illustration of the LIA3024 project",
    "projects.eternua-robot-h2-plus-ultimate-n.title": "H2 Plus Ultimate-N robot",
    "projects.eternua-robot-h2-plus-ultimate-n.alt": "Illustration of a silver humanoid in a laboratory.",
    "projects.eternua-robot-h2-plus-ultimate-n.caption": "Illustration of the proposed robot",
    "projects.eternua-infrastructure-ia-double-epyc.title": "Dual EPYC AI infrastructure",
    "projects.eternua-infrastructure-ia-double-epyc.alt": "Conceptual illustration of a dual-processor server for Eternua’s proposed AI infrastructure.",
    "projects.eternua-infrastructure-ia-double-epyc.caption": "Conceptual illustration of the proposed server.",
    "projects.eternua-villa-julia-centre.title": "Villa Julia project",
    "projects.eternua-villa-julia-centre.alt": "Conceptual view of a Mediterranean villa envisaged as a future Eternua development centre.",
    "projects.eternua-villa-julia-centre.caption": "Conceptual view of the future Eternua centre."
  }
};
